import { render, staticRenderFns } from "./value_addservices.vue?vue&type=template&id=79222a85&scoped=true"
import script from "./value_addservices.vue?vue&type=script&lang=js"
export * from "./value_addservices.vue?vue&type=script&lang=js"
import style0 from "./value_addservices.vue?vue&type=style&index=0&id=79222a85&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79222a85",
  null
  
)

export default component.exports